<template>
  <div v-if="data"
    id="recommended"
    class="my-vacancies-page__recommended"
  >
    <h2 class="my-vacancies-page__recommended-title d-none d-md-block">{{$tMyVacancy('Recommended')}}</h2>

    <div class="my-vacancies-page__recommended-content">
      <div class="my-vacancies-page__recommended-main">
        <div class="my-vacancies-page__recommended-cards">
          <VacancyCard
            v-if="data"
            ref="vacancyCard"
            :data="data"
          />

          <div
            v-else
            :style="{ height: `${prevHeight}px` }"
          />
        </div>

        <button
          class="my-vacancies-page__recommended-btn"
          type="button"
          @click="$emit('reload')"
        >
          <BaseSvg name="ico-close"/>
          <span>{{ $tMyVacancy('Not interesting') }}</span>
          <sub>({{ $tMyVacancy('Show another recommendation') }})</sub>
        </button>
      </div>

      <div
        v-if="windowSizeMixin.width > 1023"
        class="my-vacancies-page__recommended-side"
      >
        <AccountMyVacanciesHelpTooltips class="my-vacancies-page__help-tooltip"/>
      </div>
    </div>
  </div>
</template>

<script>
  import windowSizeMixin from '@/mixins/windowSizeMixin';

  import VacancyCard from '@/components/vacancy-card/VacancyCard';
  import AccountMyVacanciesHelpTooltips from '@/components/myVacancies/AccountMyVacanciesHelpTooltips';

  export default {
    name: 'AccountMyVacanciesRecommendation',
    mixins: [windowSizeMixin],

    components: {
      VacancyCard,
      AccountMyVacanciesHelpTooltips
    },

    props: {
      data: {
        required: true
      }
    },

    data: () => ({
      prevHeight: 0
    }),

    watch: {
      data() {
        setTimeout(() => {
          const height = ((this.$refs.vacancyCard || {}).$el || {}).offsetHeight;
          if (height) this.prevHeight = height;
        }, 100);
      }
    }
  };
</script>
